<template>
    <b-modal v-model="showModal" id="cameraAccess" size="md" centered hide-footer hide-header no-close-on-backdrop
         @hidden="close">
        <div class="d-flex">
            <div class="w-100 py-3">
                <div class="d-flex flex-column align-items-center jus position-relative">
                    <div>
                        <img src="../../../assets/toast/warning.svg" alt="" />
                    </div>
                    <div class=" w-100 mt-2 text-center pr-3">
                        Unable to access camera. Please make sure that you have camera and required permissions are given.
                    </div>
                    <strong class="pt-2">Note: Reload the page after giving permission.</strong>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>    

export default {
    name: "DeleteModal",
    props: {
        showModal: Boolean,
    },
    methods: {
        close() {
            this.$emit("close")
        },
    },
};
</script>
